import script from "./OsintProviders.vue?vue&type=script&setup=true&lang=js"
export * from "./OsintProviders.vue?vue&type=script&setup=true&lang=js"

import "./OsintProviders.vue?vue&type=style&index=0&id=d0a679d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a679d6"]])

export default __exports__